import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EditUserComponent } from './edit-user.component';
import { EditUserRoutingModule } from './edit-user-routing.module';
import { UserFormModule } from '../form/user-form.module';
import { SharedModule } from '../../../../shared/shared.module';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TextMaskModule } from 'angular2-text-mask';
import { ProfilePhotoModule } from '../../../profile/profile-photo/profile-photo.module';
import { EditUserResolve } from './edit-user.resolve';
import { VerifyCustomerGovIdModule } from '../../../../shared/admin/verify-customer-gov-id/verify-customer-gov-id.module';
import { CustomerIdUploadModule } from '../../../../customer/customer-basic-info/customer-id-upload/customer-id-upload.module';
import { AdminAffiliateInfoModule } from '../admin-affiliate-info/admin-affiliate-info.module';
import { ListGridModule } from '../../../../shared/listGrid/listGrid.module';
import { LoadingModule } from '../../../../shared/loading/loading.module';
import { PaginationModule } from '../../../../shared/pagination/pagination.module';

@NgModule({
  imports: [
    CommonModule,
    EditUserRoutingModule,
    FormsModule,
    AppMaterialModule,
    SharedModule,
    MatSlideToggleModule,
    TextMaskModule,
    MatDatepickerModule,
    ProfilePhotoModule,
    UserFormModule,
    VerifyCustomerGovIdModule,
    CustomerIdUploadModule,
    AdminAffiliateInfoModule,
    ListGridModule,
    LoadingModule,
    PaginationModule,
  ],
  declarations: [EditUserComponent],
  exports: [EditUserComponent],
  providers: [EditUserResolve],
})
export class EditUserModule {}
